import { ButtonBase, styled } from '@mui/material';
import { Icon, Text, Tooltip } from 'shell/components';

const NavigationItem = ({ active, current = active, emphasized = false, expanded, item, onClick }) => {
    const row = (
        <NavigationItemButton
            aria-current={current ? 'page' : undefined}
            aria-label={expanded ? undefined : item.text}
            active={active}
            emphasized={emphasized}
            expanded={expanded}
            onClick={item.link ? onClick : undefined}
        >
            <Icon kind={item.icon} />
            <NavigationItemLabel
                aria-hidden={!expanded}
                color={'inherit'}
                expanded={expanded}
                variant={'p2'}
                weight={'medium'}
            >
                {item.text}
            </NavigationItemLabel>
        </NavigationItemButton>
    );

    return expanded ? (
        row
    ) : (
        <Tooltip placement={'right'} title={item.text}>
            {row}
        </Tooltip>
    );
};

const NavigationItemButton = styled(ButtonBase)(({ active, emphasized, expanded, theme }) => ({
    width: expanded ? '100%' : 52,
    flexShrink: 0,
    minHeight: 32,
    padding: theme.spacing(2),
    gap: expanded ? theme.spacing(2) : 0,
    justifyContent: expanded ? 'flex-start' : 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: 8,
    color: active || emphasized ? theme.palette.ensightful.primary[900] : theme.palette.ensightful.neutral[700],
    background: active ? theme.palette.ensightful.primary[50] : 'transparent',

    '& svg': { fontSize: 20, flexShrink: 0 },

    '&:hover': {
        color: theme.palette.ensightful.primary[500],
        background: active ? theme.palette.ensightful.primary[50] : 'transparent',
    },

    '&:focus-visible': { outline: `${theme.palette.ensightful.secondary[400]} solid 3px`, outlineOffset: -2 },
}));

const NavigationItemLabel = styled(Text, {
    shouldForwardProp: (prop) => prop !== 'expanded',
})(({ expanded }) => ({
    minWidth: 0,
    maxWidth: expanded ? '100%' : 0,
    flex: expanded ? '1 1 auto' : '0 0 0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'start',
    opacity: expanded ? 1 : 0,
    visibility: expanded ? 'visible' : 'hidden',
    pointerEvents: expanded ? 'auto' : 'none',
    transition: 'opacity 80ms ease, visibility 0s linear',
    transitionDelay: expanded ? '100ms, 100ms' : '0ms, 0ms',
}));

export default NavigationItem;
